import React, { useState } from 'react';
import aititleicon from '@/assets/ai/aititleicon.png';
import aivideocard3 from '@/assets/ai/video/aivideocard3.mp4';
import aivideocard1 from '@/assets/ai/video/aivideocard1.mp4';
import aivideocard2 from '@/assets/ai/video/aivideocard2.mp4';
import './appcard.css';

function AppCard() {
    const [active, setActive] = useState('appright'); // Default active right card

    const handleMouseEnter = (card) => {
        setActive(card);
    };

    const handleMouseLeave = () => {
        setActive('appright'); // Reset to default state
    };

    return (
        <div
            className="appcontainer"
            onMouseLeave={handleMouseLeave} // Reset when mouse leaves the container
        >
            <div
                className={`appcard appleft ${active === 'appleft' ? 'appactive' : 'appcollapsed'}`}
                onMouseEnter={() => handleMouseEnter('appleft')}
            >
                {active === 'appleft' ? (
                    <div className="w-56 relative p-3">
                        <video className="absolute top-[-70px] right-[-80px] z-0" loop
                            autoPlay
                            muted
                            playsInline
                            onClick={(e) => e.preventDefault()}>
                            <source src={aivideocard1} type="video/mp4" />
                        </video>
                        <div className="relative z-[1] mt-10">
                            <p className="text-lg">
                                <img src={aititleicon} alt="" className="w-[14px] h-[14px]" />
                                <span>Interactive Chats, Personalized Growth</span>
                            </p>
                            <p className="text-base text-[#9F9F9F] mt-3">
                                Engage in real chats with Aya. Discuss game strategies, set goals, or even explore broader interests. Powered by advanced LLMs, Aya learns and evolves, becoming a smart companion tailored to your unique preferences.
                            </p>
                        </div>
                    </div>
                ) : (
                    <p className="absolute top-30 left-1/2 transform -translate-x-1/2 -rotate-90 text-[#3633F7] text-lg font-semibold whitespace-nowrap text-center">
                        Interactive Chats, Personalized Growth
                    </p>
                )}
            </div>
            <div
                className={`appcard appmiddle ${active === 'appmiddle' ? 'appactive' : 'appcollapsed'}`}
                onMouseEnter={() => handleMouseEnter('appmiddle')}
            >
                {active === 'appmiddle' ? (
                    <div className="w-56 relative p-3">
                        <video className="absolute top-[-70px] right-[-80px] z-0" loop
                            autoPlay
                            muted
                            playsInline
                            onClick={(e) => e.preventDefault()}>
                            <source src={aivideocard2} type="video/mp4" />
                        </video>
                        <div className="relative z-[1] mt-10">
                            <p className="text-lg">
                                <img src={aititleicon} alt="" className="w-[14px] h-[14px]" />
                                <span>Creating Game Assets</span>
                            </p>
                            <p className="text-base text-[#9F9F9F] mt-3">
                                Aya isn’t just a companion—she’s a creator. Collaborate with Aya to design unique game assets, including characters, items, levels, and environments. Using AIGC technology, Aya transforms your ideas into reality, supporting NFT integration and gamification.
                            </p>
                        </div>
                    </div>
                ) : (
                    <p className="absolute top-30 left-1/2 transform -translate-x-1/2 -rotate-90 text-[#3633F7] text-lg font-semibold whitespace-nowrap text-center">
                        Creating Game Assets
                    </p>
                )}
            </div>
            <div
                className={`appcard appright ${active === 'appright' ? 'appactive' : 'appcollapsed'}`}
                onMouseEnter={() => handleMouseEnter('appright')}
            >
                {active === 'appright' ? (
                    <div className="w-56 relative p-3">
                        <video className="absolute top-[-70px] right-[-80px] z-0" loop
                            autoPlay
                            muted
                            playsInline
                            onClick={(e) => e.preventDefault()}>
                            <source src={aivideocard3} type="video/mp4" />
                        </video>
                        <div className="relative z-[1] mt-10">
                            <p className="text-lg">
                                <img src={aititleicon} alt="" className="w-[14px] h-[14px]" />
                                <span>Autonomous Actions & Player Support</span>
                            </p>
                            <p className="text-base text-[#9F9F9F] mt-3">
                                Aya autonomously executes complex in-game tasks, optimizes strategies, and enhances your overall gaming experience. By analyzing your playstyle, she provides real-time recommendations and solutions, unlocking new possibilities within your gameplay.
                            </p>
                        </div>
                    </div>
                ) : (
                    <p className="absolute top-30 left-1/2 transform -translate-x-1/2 -rotate-90 text-[#3633F7] text-lg font-semibold whitespace-nowrap text-center">
                        Autonomous Actions & Player Support
                    </p>
                )}
            </div>
        </div>
    );
}

export default AppCard;
